// extracted by mini-css-extract-plugin
module.exports = {"headlineLarge":"styles_headlineLarge__1wsVV","alignCenter":"styles_alignCenter__2q_7B","alignLeft":"styles_alignLeft__2tf3q","alignRight":"styles_alignRight__QVAV9"};